/**
 * 
 * @param {Array} images - array of images
 * @returns {Function(position{number})} - function that takes the position and returns a url (string)
 * @TODO if using 'media' image urls are on the src key of the 'images' array - add check
 */

const getImageUrlByPosition = images => position => position > 0 && images.length > 0 ? images[position - 1] : ''

export default getImageUrlByPosition;